import { ChevronDown, ChevronRight } from "lucide-react";

import { ExpandButtonProps } from "./types";

const ExpandButton: React.FC<ExpandButtonProps> = ({ isExpanded, onToggle, isExpandable }) => {
  if (!isExpandable) {
    return <div className="mr-2 w-5 flex-shrink-0" />;
  }

  return (
    <button
      onClick={onToggle}
      className="mr-2 flex-shrink-0 rounded p-0.5 transition-colors hover:bg-gray-200"
    >
      {isExpanded ? (
        <ChevronDown className="h-4 w-4 text-gray-500" />
      ) : (
        <ChevronRight className="h-4 w-4 text-gray-500" />
      )}
    </button>
  );
};

export default ExpandButton;
